import { render } from "./MainPlans.vue?vue&type=template&id=a546f3fa&scoped=true"
import script from "./MainPlans.vue?vue&type=script&lang=js"
export * from "./MainPlans.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a546f3fa"

export default script